module.exports = __webpack_public_path__ + "static/img/team-4.897617b8.jpg";